import React from 'react';
import Box from '@ff/ui/Box';
import IconButton from '@ff/ui/IconButton';
import { IS_APP } from 'shared/lib/pathUtils';
import { styled } from '@ff/ui';
import setSafeAreaInsetTop from 'shared/lib/setSafeAreaInsetTop';
import { getHandlerByKey } from 'shared/lib/appHandlers';
import { isWeChatBrowser } from 'shared/lib/useragentdetection';

interface ShareNavigationProps {
  shareContent?: {
    url?: string;
    title?: string;
    text?: string;
    imageUrl?: string;
  };
}

export default function ShareNavigation({ shareContent }: ShareNavigationProps) {
  if (!IS_APP) return null;

  const handleShare = () => {
    const wechatBrowser = isWeChatBrowser();

    // Special handling for WeChat browser
    if (wechatBrowser) {
      const isCN = window.location.pathname.startsWith('/cn') || window.location.hostname.includes('faradayfuturecn');
      if (isCN) {
        alert('点击右上角"..."去分享');
      } else {
        alert('Click the 3 dots in the upper right corner to share');
      }
      return;
    }

    // Use app handler for normal cases
    const handler = getHandlerByKey('Share', {
      url: shareContent?.url || window.location.href,
      title: shareContent?.title || document.title,
      description: shareContent?.text || '',
      image: shareContent?.imageUrl || '',
    });
    handler();
  };

  return (
    <Container>
      <StyledIconButton
        icon='ff-icon-share_2'
        iconProps={{ fontSize: 18 }}
        onClick={handleShare}
      />
    </Container>
  );
}

const StyledIconButton = styled(IconButton)({
  alignItems: 'center',
  background: 'rgba(23, 26, 32, 0.35)',
  borderRadius: '50%',
  color: 'white',
  display: 'flex',
  height: '34px',
  justifyContent: 'center',
  padding: '6px',
  transition: 'background 0.3s ease, color 0.3s ease',
  width: '34px',
  '&:hover': {
    background: 'rgb(105, 106, 110)',
    color: 'white',
  },
});

const Container = styled(Box)({
  position: 'fixed',
  top: IS_APP ? `calc(${setSafeAreaInsetTop()} - 7px)` : 10,
  // disable tap highlight for APP
  WebkitTapHighlightColor: 'transparent',
  right: 15,
  zIndex: 100
}); 